<template>
  <div style="padding:10px;font-size:14px">
    <el-card style="width:500px;margin:100px auto;background:#fff;">
      <div slot="header">punchout模拟第三方跳转</div>
      <div>
        <el-form ref="formName" :rules="rules" :model="formData" label-width="80px">
          <el-form-item label="用户名" prop="USERNAME">
            <el-input v-model="formData.USERNAME"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="PASSWORD">
            <el-input v-model="formData.PASSWORD"></el-input>
          </el-form-item>
          <el-form-item label="回调地址" prop="CALLBACK_URL">
            <el-input v-model="formData.CALLBACK_URL"></el-input>
          </el-form-item>
          <div style="text-align:center">
            <el-button type="primary" @click="saveBtn"
              >模拟登陆punchout</el-button
            >
          </div>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'punchoutSimulation',
  data () {
    return {
      formData: {
        USERNAME: '',
        PASSWORD: '',
        CALLBACK_URL: ''
      },
      rules: {
        USERNAME: [{ required: true }],
        PASSWORD: [{ required: true }],
        CALLBACK_URL: [{ required: true }]
      }
    }
  },
  computed: {},
  created () {
    // 测试账号 13216205771 1234qwer
    // 测试账号 13003090721 qwer0000
  },
  mounted () {},
  methods: {
    // 跳转
    saveBtn () {
      // saveBtn
      this.$refs['formName'].validate(valid => {
        if (valid) {
          let params = Object.assign({}, this.formData)
          const Base64 = require('js-base64').Base64
          params.PASSWORD = Base64.encode(params.PASSWORD)
          this.$router.push({
            name: 'punchoutLogin',
            query: params
          })
        } else {
          this.$message({
            message: '请完善表单信息',
            type: 'warning'
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
